export default __webpack_public_path__ + "static/media/LogoTBB.892cbe74.svg";